var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag"},_vm._l((_vm.tags),function(tag,index){return _c('el-tag',{key:tag.path,class:{ 'tag-active': _vm.isActive(tag) },attrs:{"closable":"","type":"info"},on:{"click":function($event){return _vm.handleTagClick(tag)},"close":function($event){return _vm.handleTagClose(tag, index)}}},[_vm._v(" "+_vm._s(tag.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }